import { msalInstance, useAuthStore } from '@sib/auth';
import { AxiosError } from 'axios';
import { isMiddlewareUsed } from './utils';

export const handleUnauthorizedMiddleware = async (error: AxiosError) => {
  const shouldHandle = isMiddlewareUsed('handle-unauthorized', error.config);

  if (401 === error.response?.status && shouldHandle) {
    useAuthStore.getState().setAccount(null);
    await msalInstance.clearCache();

    return Promise.reject(error);
  } else {
    return Promise.reject(error);
  }
};
